// Main Export - Client-Safe by Default
// For Next.js and other client-side applications

// Export all client-safe components
export * from "./client";

// Note: For server-side RAG functionality, import from "@restnfeel/agentc-starter-kit/server"
